module.exports = __webpack_public_path__ + "static/skills-2d0f68c50261cfa21829bcc480ea0601.svg";